var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenameFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_2226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96333 10.2322L7.96333 10.2322L9.44251 8.75306C9.24119 8.66927 9.00275 8.53164 8.77724 8.30614C8.5517 8.0806 8.41406 7.84212 8.33028 7.64078L6.85108 9.11998L6.85107 9.11999C6.73564 9.23541 6.67793 9.29313 6.62829 9.35677C6.56974 9.43184 6.51954 9.51306 6.47858 9.599C6.44386 9.67186 6.41805 9.7493 6.36643 9.90416L6.0942 10.7208C6.0688 10.797 6.08863 10.8811 6.14544 10.9379C6.20224 10.9947 6.28627 11.0145 6.36248 10.9891L7.17915 10.7169C7.33402 10.6653 7.41145 10.6395 7.48431 10.6047C7.57025 10.5638 7.65148 10.5136 7.72655 10.455C7.79018 10.4054 7.8479 10.3477 7.96333 10.2322Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85296 8.34261C10.1601 8.03547 10.1601 7.5375 9.85296 7.23036C9.54582 6.92321 9.04784 6.92321 8.7407 7.23036L8.56329 7.40776L8.57086 7.43007C8.63588 7.6175 8.75857 7.8632 8.98938 8.094C9.22018 8.32481 9.46588 8.4475 9.65331 8.51252L9.67552 8.52005L9.85296 8.34261Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 4.63321C1.33331 4.04485 1.33331 3.75067 1.37955 3.50563C1.58307 2.42691 2.42685 1.58313 3.50557 1.37961C3.75061 1.33337 4.04479 1.33337 4.63314 1.33337C4.89093 1.33337 5.01982 1.33337 5.14369 1.34496C5.67775 1.3949 6.18433 1.60473 6.59727 1.94705C6.69306 2.02645 6.7842 2.11759 6.96648 2.29987L7.33331 2.66671C7.87717 3.21056 8.14909 3.48249 8.47472 3.66366C8.65361 3.76318 8.84335 3.84178 9.04021 3.89789C9.39858 4.00004 9.78314 4.00004 10.5523 4.00004H10.8014C12.5563 4.00004 13.4337 4.00004 14.0041 4.51302C14.0566 4.5602 14.1065 4.61013 14.1537 4.66259C14.6666 5.23294 14.6666 6.1104 14.6666 7.86531V9.33337C14.6666 11.8475 14.6666 13.1046 13.8856 13.8857C13.1045 14.6667 11.8475 14.6667 9.33331 14.6667H6.66665C4.15249 14.6667 2.89541 14.6667 2.11436 13.8857C1.33331 13.1046 1.33331 11.8475 1.33331 9.33337V4.63321Z",
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_2226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameFolder);
export default __webpack_public_path__ + "static/media/renameFolder.4ccfc2e270580672d0dc1d84c3a82c92.svg";
export { ForwardRef as ReactComponent };